import { PAGE_PATHS } from '@/services/paths'
import { EVENT_KEYS, sendToDataLayer } from '@/services/events'

import CustomCompleteAnatomy from '@/components/LandingPage/PageComponents/Contents/ContentDetailsSection/DetailsItem/CustomItems/CompleteAnatomy'
import CustomPathology from '@/components/LandingPage/PageComponents/Contents/ContentDetailsSection/DetailsItem/CustomItems/Pathology'
import CustomPhysiology from '@/components/LandingPage/PageComponents/Contents/ContentDetailsSection/DetailsItem/CustomItems/Physiology'
import CustomSimulator from '@/components/LandingPage/PageComponents/Contents/ContentDetailsSection/DetailsItem/CustomItems/Simulator'

const ICON_PATH = `${process.env.CDN_URL}/public/icons/modules`
const ANIMATION_PATH = `${process.env.CDN_URL}/public/animations`
const CONTENT_PATH = `${process.env.CDN_URL}/public/contents`
const CONTENT_FORMAT = 'webp'

export const CONTENTSPAGE_DATA = {
  banner: [
    {
      title: 'subtitles.contents1',
      text: 'subtitles.contents2',
      buttonText: 'buttons.askDemoNow',
      linkRoute: PAGE_PATHS.contact,
      buttonCallback: () => {
        sendToDataLayer({
          event: EVENT_KEYS.requestDemo
        })
      },
      image: `${CONTENT_PATH}/contents.${CONTENT_FORMAT}`
    }
  ],

  details: [
    {
      title: 'titles.organs',
      text: 'subtitles.organs',
      icon: `${ICON_PATH}/physiology.svg`,
      iconColor: '#F86D6E',
      menuColor: '#EF3536',
      bgColor: 'rgba(251, 95, 96, 0.1)',
      contents: [
        {
          title: 'titles.completeAnatomy',
          customComponent: CustomCompleteAnatomy,
          image: `${CONTENT_PATH}/complete_anatomy.${CONTENT_FORMAT}`
        },
        {
          title: 'titles.topographicAnatomy',
          text: 'subtitles.topographicAnatomy3',
          image: `${CONTENT_PATH}/skull.${CONTENT_FORMAT}`
        },
        {
          title: 'titles.systemicAnatomy',
          text: 'subtitles.systemicAnatomy3',
          image: `${CONTENT_PATH}/respiratory.${CONTENT_FORMAT}`,
          available: ['Web', 'App', 'VR']
        }
      ]
    },
    {
      title: 'titles.cellStructure',
      text: 'subtitles.cellStructure',
      iconColor: '#9734AD',
      bgColor: 'rgba(151, 52, 173, 0.1)',
      icon: `${ICON_PATH}/pathology.svg`,
      contents: [
        {
          title: 'titles.cytology',
          text: 'subtitles.cytology3',
          image: `${CONTENT_PATH}/cytology2.${CONTENT_FORMAT}`,
          available: ['Web', 'App']
        },
        {
          title: 'titles.histology',
          text: 'subtitles.histology3',
          image: `${CONTENT_PATH}/histology2.${CONTENT_FORMAT}`,
          available: ['Web']
        }
      ]
    },
    {
      title: 'titles.development',
      text: 'subtitles.development',
      iconColor: '#0CB56B',
      menuColor: '#06874E',
      bgColor: 'rgba(12, 181, 107, 0.1)',
      icon: `${ICON_PATH}/embryology.svg`,
      contents: [
        {
          title: 'titles.embryology',
          text: 'subtitles.embryology3',
          video: `${ANIMATION_PATH}/fetus.mp4`
        },
        {
          title: 'titles.physiology',
          text: 'subtitles.physiology3',
          customComponent: CustomPhysiology,
          video: `${ANIMATION_PATH}/lungs.mp4`,
          available: ['Web', 'App']
        }
      ]
    },
    {
      title: 'titles.specialties',
      text: 'subtitles.specialties',
      iconColor: '#8081E8',
      menuColor: '#6D6FE2',
      bgColor: 'rgba(128, 129, 232, 0.1)',
      icon: `${ICON_PATH}/radiology.svg`,
      contents: [
        {
          title: 'titles.radiology',
          text: 'subtitles.radiology2',
          image: `${CONTENT_PATH}/radiology2.${CONTENT_FORMAT}`,
          newUntil: '08/01/2023',
          available: ['Web']
        },
        {
          title: 'titles.pathology',
          text: 'subtitles.pathology3',
          customComponent: CustomPathology,
          image: `${CONTENT_PATH}/diabetes.${CONTENT_FORMAT}`,
          available: ['Web', 'App']
        },
        {
          title: 'titles.simulator',
          text: 'subtitles.simulator2',
          customComponent: CustomSimulator,
          image: `${CONTENT_PATH}/simulator.${CONTENT_FORMAT}`,
          available: ['Web']
        }
      ]
    }
  ]
}
